<template>
    <v-content>
        <v-container>
            <p class="title">Descargar solicitudes</p>
            <v-progress-circular indeterminate v-if="!solicitudes"></v-progress-circular>
            <vue-json-to-csv v-if="solicitudes && solicitudes.length > 0" :json-data="solicitudes">
                <button>
                    <v-btn color="blue">Descargar</v-btn>
                </button>
            </vue-json-to-csv>
            <v-alert v-if="solicitudes && solicitudes.length == 0" color="yellow">No hay solicitudes.</v-alert>
        </v-container>
    </v-content>
</template>

<script>
import { SolicitudInformacionesService } from "../../services/carreras-api.service"
import VueJsonToCsv from "vue-json-to-csv"
export default {
    components: { VueJsonToCsv },
    data() {
        return {
            solicitudes: null
        }
    },
    methods: {
        getSolicitudes() {}
    },
    created() {
        SolicitudInformacionesService.where({ include: "[plataforma,carrera_sede@]" }).then(solicitudes => {
            this.solicitudes = solicitudes.map(s => {
                return {
                    plataforma: s.Plataforma.plataforma,
                    nombre: s.nombreCompleto,
                    identificador: s.identificadorPais,
                    nem: s.nem,
                    carrera: s.carreraSede.alias
                }
            })
        })
    }
}
</script>
